import * as React from 'react';

import { createIcon } from '../Icon';
export const CornerUpRightIcon = createIcon(
  <React.Fragment>
    <polyline points="15 14 20 9 15 4" />
    <path d="M4 20v-7a4 4 0 0 1 4-4h12" />
  </React.Fragment>,
  'CornerUpRightIcon'
);
